import React from 'react';

const providerColors = {
  openai: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  anthropic: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  xai: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  deepseek: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  gemini: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  perplexity: 'bg-teal-500/20 text-teal-400 border-teal-500/30',
  none: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
};

const providerNames = {
  openai: 'OpenAI GPT',
  anthropic: 'Claude',
  xai: 'Grok',
  deepseek: 'DeepSeek',
  gemini: 'Gemini',
  perplexity: 'Perplexity',
  none: 'Unknown',
};

export const ProviderBadge = ({ provider, model, confidence }) => {
  const colorClass = providerColors[provider] || providerColors.none;
  const displayName = providerNames[provider] || provider;

  return (
    <div className="flex items-center gap-2 mt-2">
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${colorClass}`}>
        ✓ {displayName}
      </span>
      {model && (
        <span className="text-xs text-gray-500">
          {model}
        </span>
      )}
      {confidence !== undefined && (
        <span className="text-xs text-gray-400">
          • {Math.round(confidence * 100)}% confidence
        </span>
      )}
    </div>
  );
};

export default ProviderBadge;
